import React, { useState, useEffect, useContext } from "react";
import { store } from '../../context/store';
import { useHistory } from 'react-router-dom';

import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import DashboardSelector from "../../components/DashboardSelector";
import AssetConditionMatrixGrid from "./components/AssetConditionMatrixGrid";
import AssetDetailDrawerContent from "./components/AssetDetailDrawerContent";
import AssetDetailPopOut from "./AssetDetailPopOut";
import AmChartPie from "../../components/AmChartPie";

import { functions } from "../../constants/common-functions";

export default function AssetConditionMatrix() {

    const globalState = useContext(store);
    const { dispatch } = globalState;
    const history = useHistory();
	
	
	useEffect(() => {
		 functions.redirectDemoUser(history);
	  }, []);
	
	
	const BLACK_DRAWER_WIDTH = 300;
	const WHITE_DRAWER_WIDTH = 300;

	const BLACK_DRAWER_RIGHT_GAP = 0;      // your black drawer is right: 0
	const OPEN_LEFT_GAP = 90;              // where you want it to stop

	// When CLOSED, park the white drawer so its LEFT is exactly under the black drawer
	// Black drawer left edge = windowWidth - BLACK_DRAWER_WIDTH - BLACK_DRAWER_RIGHT_GAP
	// For a fixed positioned element, easiest is: right = BLACK_DRAWER_WIDTH, width = WHITE_DRAWER_WIDTH
	// That places its right edge at: windowRight - BLACK_DRAWER_WIDTH, i.e. directly under black drawer.

    /* =========================
       STATE (DEMO)
    ========================== */

    const [totalAreaBySpaceType, setTotalAreaBySpaceType] = useState([]);
    const [totalAreaByClassificationItem, setTotalAreaByClassificationItem] = useState([]);
    const [totalCapacityBySpaceType, setTotalCapacityBySpaceType] = useState([]);
	
	const [matrixData, setMatrixData] = useState({});
	
	
	const [detailOpen, setDetailOpen] = useState(false);
	const [assetOpen, setAssetOpen] = useState(false);

    useEffect(() => {
		
		
		// Row = Criticality, Col = Condition
		       setMatrixData({
		           "High": {
		               "Good":     { total: 62, breakdown: [40, 35, 25] },
		               "Fair":     { total: 94, breakdown: [55, 25, 20] },
		               "Poor":     { total: 71, breakdown: [60, 25, 15] },
		               "Critical": { total: 38, breakdown: [70, 20, 10] }
		           },
		           "Medium": {
		               "Good":     { total: 102, breakdown: [45, 35, 20] },
		               "Fair":     { total: 84, breakdown: [40, 40, 20] },
		               "Poor":     { total: 97, breakdown: [55, 30, 15] },
		               "Critical": { total: 73, breakdown: [65, 25, 10] }
		           },
		           "Low": {
		               "Good":     { total: 120, breakdown: [50, 30, 20] },
		               "Fair":     { total: 98, breakdown: [45, 35, 20] },
		               "Poor":     { total: 51, breakdown: [60, 25, 15] },
		               "Critical": { total: 20, breakdown: [70, 20, 10] }
		           }
		       });

        setTotalAreaBySpaceType([
            { name: "HVAC", value: 40 },
            { name: "Lighting", value: 30 },
            { name: "IT", value: 20 },
            { name: "Fire", value: 10 }
        ]);

        setTotalAreaByClassificationItem([
            { name: "Good", value: 55 },
            { name: "Fair", value: 30 },
            { name: "Poor", value: 15 }
        ]);

        setTotalCapacityBySpaceType([
            { name: "Manufacturer A", value: 45 },
            { name: "Manufacturer B", value: 35 },
            { name: "Other", value: 20 }
        ]);

    }, []);
	
	
	const openDetailDrawer = () => {
		setDetailOpen(true);
	};
	
	
	const rows = ["High", "Medium", "Low"];
	    const cols = ["Good", "Fair", "Poor", "Critical"];

	    const RAG = {
	        GREEN_STRONG: "#6fcf97",
	        GREEN: "#a8dbc2",
	        AMBER: "#ffc857",
	        RED: "#f28b82",
	        DARK_RED: "#e25d5d",
	        VERY_DARK_RED: "#d64545"
	    };

	    function ragColor(rowName, colName) {

	        if (rowName === "High" && colName === "Good") { return RAG.AMBER; }
	        if (rowName === "High" && colName === "Fair") { return RAG.RED; }
	        if (rowName === "High" && colName === "Poor") { return RAG.DARK_RED; }
	        if (rowName === "High" && colName === "Critical") { return RAG.VERY_DARK_RED; }

	        if (rowName === "Medium" && colName === "Good") { return RAG.GREEN; }
	        if (rowName === "Medium" && colName === "Fair") { return RAG.AMBER; }
	        if (rowName === "Medium" && colName === "Poor") { return RAG.RED; }
	        if (rowName === "Medium" && colName === "Critical") { return RAG.DARK_RED; }

	        if (rowName === "Low" && colName === "Good") { return RAG.GREEN_STRONG; }
	        if (rowName === "Low" && colName === "Fair") { return RAG.GREEN; }
	        if (rowName === "Low" && colName === "Poor") { return RAG.AMBER; }
	        if (rowName === "Low" && colName === "Critical") { return RAG.RED; }

	        return "#eee";
	    }

    /* =========================
       STYLES
    ========================== */

    const thisContainer = {
        display: "flex",
        position: "fixed",
        flexDirection: "column",
        width: "100%",
        minHeight: "100vh",
        left: 0,
        top: 0
    };

    const mainContainer = {
        display: "flex",
        position: "fixed",
        top: "60px",
        left: "60px",
        bottom: 0,
        right: 0,
        overflow: "hidden"
    };

    const canvas = {
        position: "absolute",
        top: 30,
        left: 240,
        bottom: 30,
        right: "380px",
        padding: "20px",
        display: "flex",
        flexDirection: "column"
    };

    const drawer = {
        position: "fixed",
        top: "90px",
        right: 0,
        bottom: 30,
        width: "300px",
        display: "flex",
        flexDirection: "column",
        padding: "24px 20px",
        background: "linear-gradient(180deg, #0b0b0d 0%, #15161a 100%)",
        boxShadow: "-12px 0 30px rgba(0,0,0,0.45)",
        color: "#fff",
        borderTopLeftRadius: "17px",
        borderBottomLeftRadius: "17px",
		zIndex:2
    };

	const metricsRail = {
	    position: "absolute",
	    top: 30,
	    left: 30,
	    width: "220px",
	    padding: "18px",
	    background: "linear-gradient(180deg, #f2f4f7 0%, #e8ebf0 100%)",
	    borderRadius: "18px",
	    boxShadow: "0 14px 32px rgba(0,0,0,0.14)",
	    display: "flex",
	    flexDirection: "column",
	    gap: "14px",
	    border: "1px solid rgba(0,0,0,0.06)"
	};
	
	
	const kpiTile = {
	    background: "linear-gradient(180deg, #10141b, #151a22)",
	    borderRadius: "14px",
	    padding: "14px 16px",
	    boxShadow:
	       "inset 0 1px 0 rgba(255,255,255,0.04), 0 8px 22px rgba(0,0,0,0.6)",
	    border: "1px solid rgba(255,255,255,0.05)",
	    display: "flex",
	    flexDirection: "column",
	    gap: "4px"
	};

	const metricLabel = {
	    fontSize: "10px",
	    letterSpacing: "0.9px",
	    textTransform: "uppercase",
	    color: "rgba(255,255,255,0.55)"
	};

	const metricValue = (color) => ({
	    fontSize: "26px",
	    fontWeight: 800,
	    color: color,
	    letterSpacing: "-0.4px"
	});

	const metricSub = {
	    fontSize: "12px",
	    color: "rgba(255,255,255,0.65)"
	};
	
	
	const kpiAccent = (color) => ({
	    width: "36px",
	    height: "3px",
	    borderRadius: "2px",
	    background: color,
	    boxShadow: `0 0 12px ${color}66`
	});

    const railDivider = {
        height: "1px",
        background: "rgba(0,0,0,0.08)"
    };

    const railSelect = {
        height: "32px",
        borderRadius: "8px",
        border: "1px solid #ddd",
        fontSize: "12px",
        padding: "0 10px",
        background: "#fff"
    };

    const railToggle = {
        display: "flex",
        background: "#eee",
        borderRadius: "16px",
        padding: "2px"
    };

    const railToggleOption = (active) => ({
        flex: 1,
        textAlign: "center",
        padding: "6px 0",
        fontSize: "12px",
        borderRadius: "14px",
        cursor: "pointer",
        background: active ? "#111" : "transparent",
        color: active ? "#fff" : "#555"
    });

  
	
	
	const pieContainer = {
	      display: "flex",
	      justifyContent: "center",
	      marginTop: "-20px"
	  };

	  const pieTitle = {
	      display: "flex",
	      justifyContent: "center",
	      fontSize: "12px",
	      opacity: 0.85,
	      marginBottom: "0px",
	      letterSpacing: "0.3px"
	  };

	  const sectionDivider = {
	      height: "1px",
	      background: "rgba(255,255,255,0.08)",
	      margin: "12px 0"
	  };
	  
	  
	  const RAG_STRONG = {
	      GREEN:      "#a8dbc2",  // healthy, confident green
	      AMBER:      "#ffc857",  // proper amber (this is key)
	      RED:        "#f28b82",  // strong red, still readable
	      DARK_RED:   "#e25d5d"   // critical / fail
	  };
	  
	  
	  const overlayStyle = {
	      position: "fixed",
	      top: 0,
	      left: 0,
	      width: "100%",
	      height: "100%",

	      background: "rgba(255,255,255,0.85)",

	      pointerEvents: "none",

	      opacity: 0,

	      animation: "fadeOverlay 4s ease forwards"
	    };

    /* =========================
       RENDER
    ========================== */

    return (
        <div style={thisContainer}>
            <Header />
            <LeftMenu />
			<div style={overlayStyle}/>
            <DashboardSelector
                title="Asset Condition Matrix"
                childDashboards={[]}
            />

            <div style={mainContainer}>

			{/* LEFT METRICS */}
			<div style={metricsRail}>

			    <div style={kpiTile}>
			        <div style={kpiAccent("#4ddad6")} />
			        <div style={metricLabel}>Total Assets</div>
			        <div style={metricValue("#4ddad6")}>2,430</div>
			    </div>

			    <div style={kpiTile}>
			        <div style={kpiAccent("#3ddc84")} />
			        <div style={metricLabel}>Total Downtime</div>
			        <div style={metricValue("#3ddc84")}>1,120</div>
			        <div style={metricSub}>hours</div>
			    </div>

			    <div style={kpiTile}>
			        <div style={kpiAccent("#b388ff")} />
			        <div style={metricLabel}>Total Cost</div>
			        <div style={metricValue("#b388ff")}>£1.8m</div>
			    </div>

			    <div style={{ height: "1px", background: "rgba(255,255,255,0.08)", margin: "8px 0" }} />

			    <select style={railSelect}><option>Building</option></select>
			    <select style={railSelect}><option>Floor</option></select>
			    <select style={railSelect}><option>Zone</option></select>

			    <div style={railToggle}>
			        <div style={railToggleOption(true)}>Assets</div>
			        <div style={railToggleOption(false)}>Properties</div>
			    </div>

			</div>

				{/* MATRIX CANVAS */}
				<div style={canvas}>
					<AssetConditionMatrixGrid
                    matrixData={matrixData}
                    rows={rows}
                    cols={cols}
                    ragColor={ragColor}
					openDetailDrawer={openDetailDrawer}
				   />
				</div>
				
				

				{/* WHITE DETAIL DRAWER */}
				<div
				    style={{
				        position: "fixed",
				        top: "90px",
				        bottom: "30px",
				        width:"calc(100% - 400px)",
				        // KEY: hide it behind black drawer by default, then slide it left to 60px
				        left: detailOpen ? "90px" : "calc(100vw - 300px)",
				        background: "#fff",
				        boxShadow: "-24px 0 48px rgba(0,0,0,0.22)",
				        borderTopLeftRadius: "22px",
				        borderBottomLeftRadius: "22px",

				        transition: "left 0.60s cubic-bezier(0.22, 0.61, 0.36, 1)",
				        zIndex: 1,
				        overflowY: "auto"
				    }}
				>
				<AssetDetailDrawerContent
				       title="Filtered Asset Detail"
				       subtitle="High Criticality / Fair Condition"
					   setAssetOpen={setAssetOpen}
				   />
				</div>

				{/* RIGHT DRAWER */}
				<div style={drawer}>
				{detailOpen && (
				    <div
				        style={{
				            display: "flex",
				            alignItems: "center",
				            justifyContent: "space-between",
				            padding: "12px 16px",
				            marginBottom: "16px",
				            borderRadius: "14px",
				            background: "linear-gradient(180deg, #6d1f1f 0%, #8e2a2a 50%, #5a1515 100%)",
				            boxShadow: "0 8px 18px rgba(0,0,0,0.45)",
				            color: "#ffd6d6",
				            fontSize: "12px",
				            fontWeight: 700,
				            letterSpacing: "0.3px"
				        }}
				    >
				        <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
				            <span style={{ fontSize: "10px" }}>●</span>
				            Filter applied
				        </span>

				        <span
				            style={{
				                cursor: "pointer",
				                fontSize: "16px",
				                padding: "0 6px",
				                lineHeight: "16px",
				                opacity: 0.9
				            }}
				            onClick={() => setDetailOpen(false)}
				        >
				            ✕
				        </span>
				    </div>
				)}
				    {/* BY CLASS */}
				    <div style={pieContainer}>
				        <AmChartPie
				            chartId="assetpie_class"
				            chartData={totalAreaBySpaceType}
				            width="200px"
				            height="200px"
				            categoryKey="name"
				            valueKey="value"
				        />
				    </div>
				    <div style={pieTitle}>Assets by Class</div>

				    <div style={sectionDivider} />

				    {/* BY MANUFACTURER */}
				    <div style={pieContainer}>
				        <AmChartPie
				            chartId="assetpie_manufacturer"
				            chartData={totalCapacityBySpaceType}
				            width="200px"
				            height="200px"
				            categoryKey="name"
				            valueKey="value"
				        />
				    </div>
				    <div style={pieTitle}>Assets by Manufacturer</div>

				    <div style={sectionDivider} />

				    {/* BY CONDITION */}
				    <div style={pieContainer}>
				        <AmChartPie
				            chartId="assetpie_condition"
				            chartData={totalAreaByClassificationItem}
				            width="200px"
				            height="200px"
				            categoryKey="name"
				            valueKey="value"
				        />
				    </div>
				    <div style={pieTitle}>Assets by Condition</div>

				</div>

            </div>
			<AssetDetailPopOut assetOpen={assetOpen} setAssetOpen={setAssetOpen}/>
        </div>
    );
}